import { Box, Flex, Heading, Image, Text, VStack } from "@chakra-ui/react"

import timeIcon from "#/assets/time.svg"

type DepositModalLongWaitTimeProps = {
  isTransactionTakingLongTime: boolean
}

export default function DepositModalLongWaitTime({
  isTransactionTakingLongTime,
}: DepositModalLongWaitTimeProps) {
  if (!isTransactionTakingLongTime) return null

  return (
    <Box bg="#F7F6DB" p="16px 28px 16px 20px" mt={8} rounded="16px">
      <Flex alignItems="flex-start" gap={5}>
        <Image src={timeIcon} mt={1} />
        <VStack gap={0} alignItems="flex-start">
          <Heading
            fontWeight={500}
            fontSize="18px"
            lineHeight="24px"
            fontFamily="riforma.medium"
            color="#5C4F09"
          >
            Taking a bit longer
          </Heading>
          <Text
            fontWeight={500}
            fontSize="16px"
            lineHeight="24px"
            fontFamily="riforma.medium"
            color="#766C37"
            letterSpacing="0.16px"
          >
            But don&apos;t worry, deposit will show up in a few minutes. Keep
            this page open.
          </Text>
        </VStack>
      </Flex>
    </Box>
  )
}
